import React from "react";
import "croppie/croppie.css";
import { connect } from "react-redux";
import { deepClone, toCamelCase } from "../../../../helpers/objectHelper";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { Avatar, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { handleResponse } from "../../../../helpers/handleresponse";
import Popper from "@material-ui/core/Popper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import styled from "styled-components";
import PublishIcon from "@material-ui/icons/Publish";
import CheckIcon from "@material-ui/icons/Check";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import docIcon from "./FiletypeIcons/doc.svg";
import jpgIcon from "./FiletypeIcons/jpg.svg";
import mpIcon from "./FiletypeIcons/mp.svg";
import pngIcon from "./FiletypeIcons/png.svg";
import svgIcon from "./FiletypeIcons/svg.svg";
import txtIcon from "./FiletypeIcons/txt.svg";
import xlsIcon from "./FiletypeIcons/xls.svg";
import pdfIcon from "./FiletypeIcons/pdf.svg";
import pptIcon from "./FiletypeIcons/ppt.svg";
import { form } from "../../../../store/reducers/cms/form/form.reducer";

const FileIcon = styled.img`
  width: 50px;
  maxwidth: 50px;
  max-height: 50px;
  height: auto;
`;

class FileUploader extends React.Component {
  state = {
    source: "",
    sourceFilename: "",
    sourceType: "",
    showConflictPopper: false,
    allowedFiletypes: [],
    uploading: false,
    showDeleteDialog: false,
    deleteTarget: null,
  };

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  componentDidUpdate(prevProps) {
    if (
        !this.props.cms.editMode &&
      this.props.attendee.orders &&
      prevProps &&
      this.props.attendee.orders[this.props.attendee.activePersonNo]?.uploadedFiles?.length != prevProps.attendee.orders[prevProps.attendee.activePersonNo]?.uploadedFiles?.length
    ) {
      this.setState({ uploading: false });
    }
  }

  onFileSelected = async (e) => {
    const { dispatch, attendee, form } = this.props;
    const file = e.target.files[0];

    const order = attendee.orders[attendee.activePersonNo];

    const key = order.sqlStateNo;

    const hasNameConflict = order[toCamelCase("UploadedFiles")]?.find((u) => u.name?.replace(`${key}_`, "") == file?.name);

    if (hasNameConflict) return this.setState({ showConflictPopper: true });

    const result = await this.toBase64(file).catch((e) => Error(e));

    if (result instanceof Error) {
      console.log("Error: ", result.message);
      this.setState({ errorMessage: result.message });
      return;
    }
    if (attendee && attendee.orders) {
      let order = attendee.orders[attendee.activePersonNo];
      console.log(order.sqlStateNo, form.sqlStateNo);
      if (!order.sqlStateNo || order.sqlStateNo != form.sqlStateNo) dispatch(attendeeActions.updateOrder(order, attendee.activePersonNo));
    }
    this.setState({ source: result, sourceFilename: file.name, sourceType: file.type, showConflictPopper: false }, this.setFileOnOrder);
  };

  setFileOnOrder = () => {
    const { dispatch, attendee } = this.props;
    const { source, sourceFilename, sourceType } = this.state;
    if (attendee && attendee.orders) {
      let order = attendee.orders[attendee.activePersonNo];

      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase("UploadedFiles")];
      let newType = undefined;
      if (!type) {
        newType = [];
      } else {
        newType = deepClone(type);
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file: source,
          name: `${order.sqlStateNo + attendee.activePersonNo}_${sourceFilename}`,
          type: sourceType,
        }),
      };
      this.setState({ uploading: true });
      fetch(`./api/files/fileUploadTemp/${order.eventId}`, requestOptions)
        .then(handleResponse)
        .then((res) => {
          newType.unshift(res);
          newOrder[toCamelCase("UploadedFiles")] = newType;
          //   console.log("pfImage", order.orderRow, order, attendee.activePersonNo);
          dispatch(attendeeActions.updateOrder(newOrder, attendee.activePersonNo));
          this.setState({ source: "", sourceFilename: "", sourceType: "" });
          console.log(this.fileInputRef);
          if (this.fileInputRef) this.fileInputRef.value = "";
        });
    }
  };
  removeUploadedFile = (file) => {
    const { attendee, dispatch } = this.props;
    if (attendee && attendee.orders) {
      let order = attendee.orders[attendee.activePersonNo];
      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase("UploadedFiles")];
      let newType = type.filter((f) => f.url !== file.url);
      newOrder[toCamelCase("UploadedFiles")] = newType;
      dispatch(attendeeActions.updateOrder(newOrder, attendee.activePersonNo));
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(file),
      };
      fetch(`./api/files/removeUploadedFile/${order.eventId}`, requestOptions);
    }

    this.setState({ deleteTarget: null });
  };

  confirmDelete = (confirmed) => {
    if (confirmed == true && this.state.deleteTarget) {
      this.removeUploadedFile(this.state.deleteTarget);
      this.setState({ showDeleteDialog: false });
    } else {
      this.setState({ showDeleteDialog: false, deleteTarget: null });
    }
  };

  render() {
    const { cms, template, element } = this.props;
    const { contentId } = this.props.element;
    const { attendee } = this.props;

    if (cms.editMode) {
      return (
        <div style={{ padding: "11px", border: "1px solid #d5d5d5", textAlign: "center" }}>
          <h3>
            <SystemLabel name="FileUploadElement" />
          </h3>
          <p>
            <SystemLabel name="ElementDoNotShowInEditMode" />
          </p>
        </div>
      );
    }

    let order = null;
    if (attendee && attendee.orders) {
      order = attendee.orders[attendee.activePersonNo];
    }

    const key = order.badgeNo || order.sqlStateNo;
    // const { size, shape, viewport, defaultImage } = this.props.settings;
    console.log(order);
    return (
      <div className="w-100 text-center" style={{ padding: 7 }}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "50%", padding: "6px", border: "1px dashed gainsboro", borderRadius: 5, background: "rgba(238, 238, 238, 0.2)", display: "flex", alignItems: "center" }}>
            <label htmlFor="file-upload" className="archive-toolbar-btn" style={{ marginRight: 10 }}>
              <FolderOpenIcon style={{ color: "#5a5959" }} />
            </label>
            {this.state.source ? this.state.sourceFilename.replace(`${key}_`, "") : <SystemLabel name="NoFileChosen" />}
          </div>
          <input
            disabled={cms.editMode}
            ref={(r) => (this.fileInputRef = r)}
            style={{ display: "none" }}
            className="form-control"
            type="file"
            id="file-upload"
            accept={element.data?.allowedFiletypes?.join("")}
            onChange={(e) => this.onFileSelected(e)}
          />
          {/*      <IconButton disabled={!this.state.source} onClick={this.setFileOnOrder}>
            <PublishIcon />
          </IconButton> */}
        </div>
        {this.state.showConflictPopper ? (
          <>
            <br />
            <Alert style={{ textAlign: "left" }} severity="error">
              <AlertTitle>
                <SystemLabel name="FileNameConflict" />
              </AlertTitle>
              <SystemLabel name="FileWithSameNameAlreadyUploaded" />
            </Alert>
          </>
        ) : null}

        {this.state.uploading ? <LinearProgress /> : <br />}
        {this.state.showDeleteDialog && this.state.deleteTarget ? <ConfirmDialog action={this.confirmDelete} /> : null}
        <List dense={false} className="jir-scroll" style={{ maxHeight: 400, overflowY: "auto" }}>
          {order && order[toCamelCase("UploadedFiles")]
            ? order[toCamelCase("UploadedFiles")].map((f, i) => {
                return (
                  <ListItem key={f.url} style={{ border: "1px solid #dedede", borderRadius: "5px", background: "#ffffff", marginBottom: 3 }}>
                    <ListItemAvatar>
                      {/*           <CheckCircleIcon style={{ background: "green" }} /> */}
                      <Avatar style={{ background: "transparent", borderRadius: 5, position: "relative" }}>
                        <FileType type={f.name.substr(f.name.lastIndexOf(".") + 1, f.name.length)} source={f.url} />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <p style={{ ...template?.content?.text, margin: 0 }} className="ellipsis">
                          {f.name.includes(`${order.sqlStateNo}_`) ? f.name.replace(`${order.sqlStateNo}_`, "") : f.name.replace(`${key}_`, "")}
                        </p>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => this.setState({ showDeleteDialog: true, deleteTarget: f })}>
                        <DeleteForeverIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })
            : null}
        </List>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template.template,
    cms: state.cms,
    attendee: state.attendee,
  };
}
export default connect(mapStateToProps)(FileUploader);

const FileType = ({ type, source }) => {
  switch (type) {
    case "pdf":
      return <FileIcon src={pdfIcon} />;
    case "doc":
    case "docx":
      return <FileIcon src={docIcon} />;
    case "jpg":
      return <FileIcon src={source || jpgIcon} />;
    case "mp4":
      return <FileIcon src={mpIcon} />;
    case "png":
      return <FileIcon src={source || pngIcon} />;
    case "svg":
      return <FileIcon src={svgIcon} />;
    case "txt":
      return <FileIcon src={txtIcon} />;
    case "xls":
    case "xlsx":
      return <FileIcon src={xlsIcon} />;
    case "ppt":
      return <FileIcon src={pptIcon} />;
    default:
      break;
  }
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function ConfirmDialog({ action }) {
  return (
    <div>
      <Dialog open={true} TransitionComponent={Transition} keepMounted onClose={action} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">
          <SystemLabel name="DeleteFile" />
        </DialogTitle>
        <DialogContent style={{ width: 350 }}>
          <DialogContentText id="alert-dialog-slide-description">
            <SystemLabel name="FileDeletePerm" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={action} color="default">
            <SystemLabel name="Cancel" />
          </Button>
          <Button onClick={() => action(true)} variant="contained" color="primary">
            <SystemLabel name="Delete" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
